<div [class.open]="isOpen$ | async" class="toast-container open">
  <div [ngClass]="classForPriority"
    class="fdx-u-elevation--z3 fdx-c-notification fdx-c-notification--block fdx-c-notification--toast fdx-c-notification--position-bottom-right">
    <div class="fdx-c-notification__main">
      <div class="fdx-c-notification__header">
        @if (poprToastPackage.config?.priority !== '16') {
          <div>
            @switch (poprToastPackage.config?.priority) {
              @case ('1') {
                <ciam-icon class="fdx-c-icon" aria-hidden="true" key="circle-exclamation"></ciam-icon>
              }
              @case ('2') {
                <ciam-icon class="fdx-c-icon" aria-hidden="true" key="exclamation-triangle"></ciam-icon>
              }
              @case ('4') {
                <ciam-icon class="fdx-c-icon" aria-hidden="true" key="check-mark-circle"></ciam-icon>
              }
              @case ('8') {
                <ciam-icon class="fdx-c-icon" aria-hidden="true" key="circle-exclamation"></ciam-icon>
              }
            }
          </div>
        }
      </div>
      <div class="fdx-c-notification__body">
        @if (poprToastPackage.config?.title) {
          <h3 class="fdx-c-toast__title">{{poprToastPackage.config?.title}}</h3>
        }
        <div class="fdx-c-notification__description">
          <p #dynamicContainer></p>
          @if (poprToastPackage.config?.button) {
            <a
              [href]="poprToastPackage.config?.button?.url || '#'"
              class="fdx-c-button fdx-c-button--text fdx-c-button--condensed">
              {{poprToastPackage.config?.button?.label}}
            </a>
          }
        </div>
      </div>
      <div class="fdx-c-notification__footer">
        <button class="fdx-c-button fdx-c-button--icon" (click)="close()">
          <ciam-icon class="fdx-c-icon" aria-hidden="true" key="cross"></ciam-icon>
        </button>
      </div>
    </div>
  </div>
</div>

